import { SecondsPipe } from './../../../pipes/seconds.pipe';
import { Component, Input, forwardRef, ElementRef, Output, EventEmitter, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'bb-slider',
	templateUrl: './bb-slider.component.html',
	styleUrls: ['./bb-slider.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => BbSliderComponent),
			multi: true
		},
		SecondsPipe
	]
})

export class BbSliderComponent implements ControlValueAccessor, OnInit {
	@Input() min: number;
	@Input() max: number;
	@Input() step: any;
	@Output() onChanged = new EventEmitter<number>();
	@Input() size: string;
	@Input() labelFilter: any;
	@Input() displaySuffix: string;

	innerValue: number;
	dragging: boolean;
	displayValue: string;
	progress: any;

	constructor(el: ElementRef, private secondsPipe: SecondsPipe) {
		this.dragging = false;
		this.innerValue = 0;
	}

	ngOnInit() {
		// determine our current values
		this.setPosition(0);
	}

	setPosition(value: number) {

		// update out innner value
		this.innerValue = value;

		// start setting the visual positions
		const percentage = Math.round((value / this.max * 100));
		this.progress = { width: + percentage + '%' };

		// initiate propagating
		this.applyChange();
		this.updateDisplayValue();

	}

	applyChange() {
		if (this.dragging) {
			this.propagateChange(this.innerValue);
			this.onChanged.emit(this.innerValue);
		}
	}

	updateDisplayValue() {
		if (!this.innerValue) {
			this.innerValue = 0;
		}
		switch (this.labelFilter) {
			default:
				this.displayValue = String(Number(this.innerValue).toFixed(2));
				break;

			case 'seconds':
				this.displayValue = this.secondsPipe.transform(this.innerValue, '');
				break;

			case 'rounded':
				this.displayValue = '' + Math.round(this.innerValue);
				break;
		}
	}

	valueChanged(value: number) {
		if (this.innerValue !== value && this.dragging) {
			this.innerValue = value;
			this.propagateChange(this.innerValue);
			this.onChanged.emit(this.innerValue);
		}
	}

	toggleDragging(bool: boolean) {
		this.dragging = bool;
	}

	// From ControlValueAccessor interface
	writeValue(value: number) {
		if (value !== this.innerValue) {
			this.innerValue = Number(value);
			this.setPosition(value);
		}
	}

	propagateChange(_: any) { }

	// From ControlValueAccessor interface
	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	// From ControlValueAccessor interface
	registerOnTouched(fn: any) {
		// this.onTouchedCallback = fn;
	}
}
